import { createFileRoute } from '@tanstack/react-router';
import { HrEmployeesPage } from '../../../../components/portals/hr/HrEmployeesPage';

export const Route = createFileRoute('/portal/managers/hr/employees')({
  component: HrEmployeesPage,
});
